export default __webpack_public_path__ + "static/2-f597adb3a4ffc2db74c0b91f1f808869.jpg";